/**
 * Contratos de datos — notas de voz UDV (Fase 1 + stubs Fases 2–4).
 *
 * @typedef {'MOBILE_PWA'|'DESKTOP_STUDIO'} DeviceType
 *
 * @typedef {Object} ViewportSnapshot
 * @property {number} [zoom]
 * @property {number} [pan_x]
 * @property {number} [pan_y]
 * @property {number} [wl]
 * @property {number} [ww]
 *
 * @typedef {Object} AlignmentEvent
 * @property {number} timestamp_sec
 * @property {number} [slice_index]
 * @property {string} [series_uid]
 * @property {number} [image_position_patient_z]
 * @property {ViewportSnapshot} [viewport]
 *
 * @typedef {Object} AlignmentPayload
 * @property {DeviceType} device_type
 * @property {string} [study_instance_uid]
 * @property {string} [series_uid]
 * @property {AlignmentEvent[]} events
 *
 * @typedef {Object} VoiceMetadata
 * @property {DeviceType} device_type
 * @property {string} [study_instance_uid]
 * @property {string} [series_uid]
 * @property {string} [modality]
 * @property {string} [body_part]
 * @property {string} [sample_id_hash]
 * @property {number} [duration_ms]
 * @property {string} [created_at]
 *
 * @typedef {Object} TranscriptWord
 * @property {string} word
 * @property {number} start
 * @property {number} end
 *
 * @typedef {Object} TranscriptPayload
 * @property {string} text
 * @property {TranscriptWord[]} [words]
 * @property {'local_whisper'|'gateway'|'hybrid'|'live_speech'} [source]
 *
 * @typedef {'pending'|'ready'|'error'|'skipped'} TranscriptStatus
 *
 * @typedef {Object} IngestRequest
 * @property {Blob|File} audio
 * @property {AlignmentPayload} alignment
 * @property {VoiceMetadata} metadata
 * @property {TranscriptPayload} [transcript]
 *
 * @typedef {Object} IngestResponse
 * @property {string} [sample_id_hash]
 * @property {'accepted'|'skipped'|'error'} status
 * @property {string} [message]
 */

export const DEVICE_TYPES = {
  MOBILE_PWA: 'MOBILE_PWA',
  DESKTOP_STUDIO: 'DESKTOP_STUDIO',
}

export const VOICE_NOTE_FILENAME = 'nota_medica.mp3'
export const VOICE_MP3_BITRATE = 96
export const VOICE_INGEST_PATH = '/api/v1/voice-notes/ingest'
